import { render } from "./CommissionsList.vue?vue&type=template&id=fd3e36f2&scoped=true&ts=true"
import script from "./CommissionsList.vue?vue&type=script&lang=ts"
export * from "./CommissionsList.vue?vue&type=script&lang=ts"

import "./CommissionsList.vue?vue&type=style&index=0&id=fd3e36f2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd3e36f2"]])

export default __exports__